module.exports = __webpack_public_path__ + "img/reimu hakurei scarlet.15bf53a5.png";